import { ThemeProperties } from '../../core';

export interface SkeletonLoaderTheme {
	background: string;
	shimmerColor: string;
	borderRadius: string;
}
export const theme = new ThemeProperties('skeletonLoader');
